module.exports = __webpack_public_path__ + "static/media/twitter-icon.d26418c4.svg";